import { Quote } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

const REFLECTIONS = [
  {
    quote: "Working one-on-one with Sheetal helped me step out of constant overwhelm and see my daily habits clearly. Within a few sessions, I felt a shift in my energy, my work boundaries, and how I show up for my family.",
    detail: "1:1 Lifestyle Coaching Client",
  },
  {
    quote: "Sheetal creates a remarkably calm and grounded space. Her coaching didn't just give me surface-level advice - it helped me recognize old mindset patterns and build a more active, intentional daily routine.",
    detail: "1:1 Personal Development Client",
  },
  {
    quote: "The private sessions gave me the clarity I needed during a major career and life transition. I walked away with practical tools, steadier focus, and a quiet confidence in my own direction.",
    detail: "1:1 Mindset & Habit Coaching",
  },
];

export const Testimonials = () => (
    <section className="bg-[#f2ebe0] py-24 md:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <SectionHead size="large" eyebrow="Client reflections" title={<>Experiences from <span className="coaching-numerals">1:1</span> Coaching</>}
          text="In their own words: how private coaching sessions have supported clients in finding clarity, shifting habits, and reconnecting with themselves." />
        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
            {REFLECTIONS.map((reflection) => (
              <figure key={reflection.detail} className="m-0 flex min-w-0 flex-col rounded-[1.75rem] border border-[#e0d3bf] bg-[#fffaf3] p-7 sm:p-8">
                <Quote aria-hidden="true" className="h-7 w-7 text-[#a8792a]" strokeWidth={1.25} />
                <blockquote className="font-display mt-6 flex-1 text-[1.625rem] font-medium leading-[1.4] text-[#221e1b] sm:text-[1.75rem]">“{reflection.quote}”</blockquote>
                <figcaption className="mt-8 border-t border-[#e4dacb] pt-5">
                  <p className="text-sm font-medium leading-relaxed text-[#5d544c]">{reflection.detail}</p>
                </figcaption>
              </figure>
            ))}
        </div>
      </div>
    </section>
);
